import type { OrderItem } from '@octave/contracts';

interface DeviceItemMetadataProps {
  item: OrderItem;
}

export function DeviceItemMetadata({ item }: DeviceItemMetadataProps) {
  const { metadata } = item;

  if (metadata.type !== 'DEVICE') {
    return null;
  }

  return (
    <div className="mt-2 space-y-2">
      <div className="text-xs text-slate-500">
        {metadata.brand && metadata.model && (
          <div>
            Marque/Modèle: {metadata.brand} {metadata.model}
          </div>
        )}

        {metadata.category && <div>Catégorie: {metadata.category}</div>}

        {metadata.condition && (
          <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold bg-sky-50 text-sky-700">
            {metadata.condition === 'NEW' ? 'Neuf' : 'Occasion'}
          </span>
        )}

        <div className="mt-2 flex gap-2">
          {metadata.deviceCapacity && (
            <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold bg-slate-100 text-slate-600">
              {metadata.deviceCapacity}GB
            </span>
          )}
          {metadata.deviceColor && (
            <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold bg-slate-100 text-slate-600">
              {metadata.deviceColor}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
